import './PardotCompletionActionReferenceTypeFilter.scss';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import React from 'react';
import { Select } from 'antd';
import { getSonarObjectTypeAndSourceLabel, getSonarObjectTypeId, isPardotType } from '@sonar-software/sonar-ts-lib';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
const options = Object.values(SonarObjectType)
    .filter(isPardotType)
    .map((type) => {
    var _a;
    return ({
        label: (_a = getSonarObjectTypeAndSourceLabel(type)) !== null && _a !== void 0 ? _a : '',
        value: getSonarObjectTypeId(type)
    });
});
export const PardotCompletionActionReferenceTypeFilter = ({ onChange, selected }) => React.createElement(Select, { allowClear: true, className: 'pardot-completion-action-reference-type-filter', filterOption: caseInsensitiveContainsFilterOption, onChange: (type) => onChange({ type }), options: options, placeholder: 'Filter by Type', value: selected });
